import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Order } from "../../../../api/orders";
import { RefObject } from "react";
import { Link } from "react-router-dom";
import { useAuthUser } from "../../hooks/useAuthUser";
import { useCompanyDetails } from "../../../../hooks/useCompanyDetails";
import { getBusinessOrderEmail } from "../../../../utils/businessOrderEmail";
import { getShippingAddress } from "../../utils/getShippingAddress";

type OrderPlacedMessageProps = {
  order: Order;
  printableRef: RefObject<HTMLDivElement | null>;
};
const OrderPlacedMessage = ({
  order,
  printableRef,
}: OrderPlacedMessageProps) => {
  const { details } = useAuthUser();
  const { data: companyDetails } = useCompanyDetails();
  const businessOrderEmail = getBusinessOrderEmail(companyDetails);
  const delivery = () => {
    if (order.deliveryMethod === "shipping") {
      return (
        <>
          <p>
            We will deliver your order to your{" "}
            <span className="bold">
              company address: {getShippingAddress(details)}
            </span>
            . The delivery day and time is specified in your contract.
          </p>
        </>
      );
    }
    return (
      <p>
        You are welcome to pick up your order at your agreed upon pickup day and
        time. You find this in your contract. <br />
        The pickup location is:{" "}
        <span className="bold">Alnarp's Farm (Malmövägen 3, 234 32 Lomma)</span>
        .
      </p>
    );
  };

  return (
    <>
      <div>
        <div>
          <div className="header-plus-button">
            <Link to="/dashboard/business" className="btn">
              <FontAwesomeIcon icon={faXmark} style={{ color: "#ffffff" }} />
            </Link>
            <h2>Order Confirmed</h2>
          </div>
          <div className="info-card">
            <p>Your order has been placed!</p>
            {delivery()}
            <p>
              If you have any questions, feel free to contact us at{" "}
              <a
                href={`mailto:${businessOrderEmail}`}
                style={{ color: "var(--green-700)" }}
              >
                {businessOrderEmail}
              </a>
              !
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderPlacedMessage;
